export class StringUtils {
  static toCamelCase(str: string): string {
    const strAux = str.toLowerCase();
    return strAux.replace(/[-_](.)/g, (_, char) => char.toUpperCase());
  }

  /** Transforma camelCase em dash-case */
  static camelToDashCase(str: string): string {
    return str
      .replace(/([a-z])([A-Z])/g, '$1-$2') // Insere um hífen antes de uma letra maiúscula
      .toLowerCase();
  }

  static camelToUnderlineCase(str: string): string {
    return str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase(); // Insere um '_' antes de uma letra maiúscula
  }

  static spaceToUnderlineCase(str: string): string {
    return str.replace(/ /g, '_');
  }

  /** Transforma só a primeira letra da frase em maiúscula */
  static capitalize(str: string): string {
    if (!str || str.length === 0) {
      return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  static titlecase(text: string): string {
    return text
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  /**
   *
   * Mascarar string de entrada com '*' no lugar dos caracteres.
   * Por padrão mostra apenas 30% da string original e mascara o restante.
   *
   * @param visiblePercent Percentual que não deve ser mascarado da string original. (Default: 30)
   *
   */
  static maskString(input: string, visiblePercent = 30): string {
    const max = 70;
    const min = 10;

    if (!input) {
      return '';
    }
    // Obter percentual visível dentro dos parâmetros mínimo e máximo
    visiblePercent = Math.min(Math.max(visiblePercent, min), max);

    const qtyVisible = Math.ceil((visiblePercent / 100) * input.length);
    const visiblePart = input.slice(0, qtyVisible);
    const maskedPart = '*'.repeat(input.length - qtyVisible);

    return visiblePart + maskedPart;
  }

  /** Retornar string apenas com os números da string informada */
  static onlyNumber(input?: string): string {
    if (!input) {
      return '';
    }
    return input.replace(/\D/g, '');
  }

  static removeSpecialCharacters(input: string): string {
    return input.replace(/[^a-zA-Z0-9]/g, '');
  }

  /**
   * Retornar senha randômica com base nas opções informadas.
   * Por padrão gera uma senha numérica de 8 caracteres e possuem opções para gerar com letras maiúsculas, minúsculas e caracteres especiais
   */
  static generatePassword(
    options: { length: number; numbers?: boolean; lowercase?: boolean; uppercase?: boolean; symbols?: boolean } = {
      length: 8,
      numbers: true,
    },
  ): string {
    const { length } = options;
    const charSets = {
      lowercase: 'abcdefghijklmnopqrstuvwxyz',
      uppercase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      numbers: '0123456789',
      symbols: '!@#$%^&*()-_=+[]{}|;:,.<>?',
    };

    const characterPool = Object.entries(charSets)
      .filter(([key]) => options[key as keyof typeof charSets])
      .map(([, value]) => value)
      .join('');

    if (!characterPool) {
      throw new Error('At least one character type must be enabled.');
    }

    return Array.from({ length }, () => characterPool[Math.floor(Math.random() * characterPool.length)]).join('');
  }

  /**
   * Converte valor string para number
   */
  static toNumber(value: number | string, defaultValue?: number): number | undefined {
    if (value === null || value === undefined || value === '') {
      return defaultValue;
    }

    let convertNumber: number;

    if (typeof value === 'string') {
      const trimmed = value.trim();

      convertNumber = Number(trimmed);
    } else {
      convertNumber = value;
    }

    return Number.isFinite(convertNumber) ? convertNumber : defaultValue;
  }

  static toAccentInsensitiveRegex(value: string): string {
    // 1. Escapa caracteres especiais de Regex
    const escapedQuery = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    // 2. Substitui as letras pelas suas variações acentuadas
    return escapedQuery
      .replace(/[aáàãâä]/gi, '[aáàãâäAÁÀÃÂÄ]')
      .replace(/[eéèêë]/gi, '[eéèêëEÉÈÊË]')
      .replace(/[iíìîï]/gi, '[iíìîïIÍÌÎÏ]')
      .replace(/[oóòõôö]/gi, '[oóòõôöOÓÒÕÔÖ]')
      .replace(/[uúùûü]/gi, '[uúùûüUÚÙÛÜ]')
      .replace(/[cç]/gi, '[cçCÇ]')
      .replace(/[nñ]/gi, '[nñNÑ]');
  }
}
